<template>
    <section class="col s12">
		<template v-for="item in itens">
			<div v-if="item.descricao=='Relatório da ação extraído do SIGA' && item.anexo" style="display: inline;">          
				<a class="btn-flat blue-text"
				   target="_blank"
				   :download="item.anexo.nome_anexo"
				   :href="linkParaDownload(item.anexo_id, item.anexo.arquivo, item.anexo.tipo_arquivo_extenso)">
					<i class="material-icons left">file_download</i>
					{{ item.anexo.nome_anexo }}
				</a>

				<input type="hidden" :name="`item_nome_anexo_[${item.id}]`" :value="item.anexo.nome_anexo">

				<input type="hidden" :name="`item_tamanho_anexo_kb_[${item.id}]`" :value="item.anexo.tamanho_arquivo_kb">

				<input type="hidden" :name="`item_tamanho_anexo_mb_[${item.id}]`" :value="item.anexo.tamanho_arquivo_mb">
										
			</div>
		</template>
		<br><br>
		
        <!-- VALIDAÇÃO DO ITEM -->
        <div class="row">
            <div class="col s12">

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="relatorio_acao_validacao_selecionada_siga"
                               class="with-gap"
                               type="radio"
                               id="rdNaoSeAplicaRAVS_siga"
                               :disabled="allDisabled"
                               value="nao_se_aplica"
                               v-model="validacaoSelecionadaSiga" />
                        <span>Não se aplica</span>
                    </label>
                </div>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="relatorio_acao_validacao_selecionada_siga"
                               class="with-gap"
                               type="radio"
                               id="rdAtendeRAVS_siga"
                               :disabled="allDisabled"
                               value="atende"
                               v-model="validacaoSelecionadaSiga" />
                        <span>Atende</span>
                    </label>
                </div>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="relatorio_acao_validacao_selecionada_siga"
                               class="with-gap"
                               type="radio"
                               id="rdNaoAtendeRAVS_siga"
                               :disabled="allDisabled"
                               value="nao_atende"
                               v-model="validacaoSelecionadaSiga" />
                        <span>Não atende</span>
                    </label>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import file_uploads from "../../../utils/file_uploads";

export default {
    name: "at_relatorio_acao_siga",
    props: {
        pValidacaoSelecionadaSiga: {
            type: String,
            default: null,
        },
		pItens: {
            type: Array,
            default: () => { return [] }
        },
        allDisabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
			itens: this.pItens,
            validacaoSelecionadaSiga: this.pValidacaoSelecionadaSiga,
        }
    },
    watch: {
        pValidacaoSelecionadaSiga(newValue) {
            this.validacaoSelecionadaSiga = newValue
        },
        validacaoSelecionadaSiga(newValue) {
            this.$emit('update:pValidacaoSelecionadaSiga', newValue)
        },
    },
	methods: {
		linkParaDownload(anexoId = null, arquivo = null, tipo_arquivo_extenso = null){
            return file_uploads.linkParaDownloadDeAnexosDeItemDaInscricao(anexoId, arquivo, tipo_arquivo_extenso)
        }
	}
}
</script>

<style scoped>

</style>
